import { Instagram, ArrowUpRight } from "lucide-react";
import BeholdWidget from "@behold/react";
import { INSTA_IMAGES, INSTAGRAM_URL, INSTAGRAM_HANDLE } from "@/data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const FEED_ID = process.env.REACT_APP_BEHOLD_FEED_ID;

export const InstagramSection = () => (
  <section id="instagram" data-testid="instagram-section" className="bg-espresso-dark grain relative py-24 md:py-36">
    <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10 text-center">
      <SectionHeading chapter="13" eyebrow="Instagram" title="Follow Momay Caterers" dark align="center" />
      <Reveal delay={0.1}>
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="instagram-handle" className="inline-block mt-4 font-script text-4xl md:text-5xl text-gold hover:text-cream transition-colors">
          {INSTAGRAM_HANDLE}
        </a>
      </Reveal>

      {FEED_ID ? (
        <Reveal className="mt-14">
          <div data-testid="instagram-live-feed" className="bg-cream p-4 md:p-8 text-left">
            <BeholdWidget feedId={FEED_ID} />
          </div>
        </Reveal>
      ) : (
        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="instagram-curated-grid">
          {INSTA_IMAGES.map((img, i) => (
            <Reveal key={img} delay={i * 0.06}>
              <a
                data-testid={`instagram-tile-${i}`}
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block overflow-hidden aspect-square"
              >
                <img src={img} alt="Momay Caterers food and event highlights on Instagram" loading="lazy" className="w-full h-full object-cover scale-105 group-hover:scale-100 transition-transform duration-[1.1s]" />
                <div className="absolute inset-0 bg-espresso/0 group-hover:bg-espresso/50 transition-colors duration-500 flex items-center justify-center">
                  <Instagram size={26} className="text-cream opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      )}

      <Reveal className="mt-12">
        <a
          data-testid="follow-instagram-btn"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-3 border border-gold text-gold px-10 py-4 text-xs tracking-[0.3em] uppercase hover:bg-gold hover:text-espresso transition-colors duration-300"
        >
          Follow Us on Instagram
          <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </a>
      </Reveal>
    </div>
  </section>
);
